export default "__VITE_ASSET__DrcwHUfb__"